<footer class="footer">
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-12 col-sm-12 text-center footer_content">
        © 2025 Copyright, <b style="color:#1E293B">LinkageIT</b>®
      </div>
    </div>
  </div>
</footer>
